class SubscribeForm {

  constructor (form) {
    this.form = form

    const self = this
    this.form.addEventListener('submit', (e) => {
      e.preventDefault()

      const formData = new FormData(self.form)

      $.ajax({
        type: 'POST',
        url: localize_script.admin_ajax,
        data: formData,
        async: false,
        cache: false,
        contentType: false,
        enctype: 'multipart/form-data',
        processData: false,
        success: function (results) {

          self.form.classList.add('apply-success')


        },
      })



    })

  }

}

const subscribe_forms = document.querySelectorAll('.apply-for-newsletter-form')
subscribe_forms.forEach(form => {
  new SubscribeForm(form)
})
